.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.category-banner-container {
  margin: 15px -15px 0;
}

@media screen and (max-width: 979px) {
  .category-banner-container {
    margin-right: -10px;
    margin-left: -10px;
  }
}

@media screen and (min-width: 980px) {
  .category-banner-container {
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
  }
}

.category-banner {
  padding: 15px 15px 20px;
  background-color: #ffffff;
  border: 1px solid #e7e6e6;
}

@media screen and (max-width: 979px) {
  .category-banner {
    padding: 10px 10px 20px;
  }
}

@media screen and (min-width: 980px) {
  .category-banner {
    position: relative;
    padding: 0;
    border: none;
  }
}

.category-banner__image-container {
  position: relative;
  margin-bottom: 20px;
  padding-top: 40%;
  height: 0;
  overflow: hidden;
}

@media screen and (max-width: 979px) {
  .category-banner__image-container {
    margin-bottom: 10px;
    padding-top: 28.57%;
  }
}

@media screen and (min-width: 980px) {
  .category-banner__image-container {
    position: absolute;
    height: 100%;
    padding-top: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .category-banner__image-container::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  :host(:not([dir="rtl"])) .category-banner__image-container::after {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.65) 51%, rgba(0, 0, 0, 0.3) 100%);
  }

  :host([dir="rtl"]) .category-banner__image-container::after {
    background: linear-gradient(-90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.65) 51%, rgba(0, 0, 0, 0.3) 100%);
  }
}

.category-banner__image {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.category-banner__image source {
  width: 100%;
  height: 100%;
}

.category-banner__image img {
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

:host(:not([dir="rtl"])) .category-banner__image img {
  right: 0;
}

:host([dir="rtl"]) .category-banner__image img {
  left: 0;
}

@media screen and (min-width: 980px) {
  .category-banner__content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (min-width: 980px) {
  .category-banner__content-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 720px;
    min-height: 300px;
    padding: 40px 60px 30px;
  }
}

.category-banner__heading {
  margin-bottom: 15px;
  font-size: 1.875rem;
  line-height: 2.5rem;
  color: #333333;
}

@media screen and (min-width: 980px) {
  .category-banner__heading {
    font-size: 2.625rem;
    line-height: 3rem;
    color: #ffffff;
    margin: 0 0 8px;
  }
}